import Vue from 'vue';

function generateWarning(child: string, parent: string) {
  return () =>
    console.warn(`The ${child} component must be used inside a ${parent}`);
}

export function RegistrableInject(
  namespace: any,
  child?: string,
  parent?: string
) {
  let defaultImpl = null;
  if (child && parent) {
    defaultImpl = {
      register: generateWarning(child, parent),
      unregister: generateWarning(child, parent)
    };
  }

  return Vue.extend({
    name: 'registrable-inject',

    inject: {
      [namespace]: {
        default: defaultImpl
      }
    }
  });
}

export function RegistrableProvide(namespace: string) {
  return Vue.extend({
    name: 'registrable-provide',

    methods: {
      register: null,
      unregister: null
    },
    provide() {
      return {
        [namespace]: {
          register: this.register,
          unregister: this.unregister
        }
      };
    }
  });
}
